// extracted by mini-css-extract-plugin
module.exports = {"keyboard":"_d50ab37"};